import VueLoader from '../../default/vue-loader'

import HotelOverview from '../contracted_hotels/contracted_hotel_overview'
import BottomForm from './bottom_form/form'
import MaintenaceMode from './bottom_form/maintenance_message'
import HotelTable from './package_contracted_hotel_section/hotels-table'
import PackageAvailable from './bottom_form/package_available'
import { store } from'../../default/store'

export default {
  loadBottomForm() {
    let packageDiv = document.getElementById('packageCartFormData')
    let contractHotelPage = document.getElementById('hotelPage')
    let noPurchasing = document.getElementById('packageCartFormAvailable')
    let hotelTable = document.getElementById('contractHotels')
    if(window.maintenance_mode){
      VueLoader.loadVueComponent(MaintenaceMode, document.getElementById('addToCartVue'), store)
    } else if (packageDiv) {
      VueLoader.loadVueComponent(BottomForm, document.getElementById('addToCartVue'), store)
    } else if (noPurchasing) {
      VueLoader.loadVueComponent(PackageAvailable, document.getElementById('addToCartVue'), store)
    } else if (contractHotelPage) {
      this.loadContractedHotel()
    }

    if(hotelTable){
      VueLoader.loadVueComponent(HotelTable, document.getElementById('contractHotels'), store)
    }
  },

  async loadContractedHotel(){
    VueLoader.loadVueComponent(HotelOverview, document.getElementById('hotelPage'), store)
  }
}
